<template>
  <v-app-bar app class="fill-height" clipped-right fixed flat >
    <slot name="page-fixed-header" />
  </v-app-bar>
</template>

<script>
export default {
  name: "PageHeader",
};
</script>

<style scoped>
</style>